import { render, staticRenderFns } from "./CustomerInvoicesOverview.vue?vue&type=template&id=43754774&scoped=true&"
import script from "./CustomerInvoicesOverview.vue?vue&type=script&lang=js&"
export * from "./CustomerInvoicesOverview.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInvoicesOverview.vue?vue&type=style&index=0&id=43754774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43754774",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43754774')) {
      api.createRecord('43754774', component.options)
    } else {
      api.reload('43754774', component.options)
    }
    module.hot.accept("./CustomerInvoicesOverview.vue?vue&type=template&id=43754774&scoped=true&", function () {
      api.rerender('43754774', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/CustomerInvoices/CustomerInvoicesOverview.vue"
export default component.exports